import { faHome, faBuilding } from "@fortawesome/pro-light-svg-icons"
import { TENANT_ADMIN_ORGANIZATION_ROUTE, TENANT_ADMIN_ROUTE, TENANT_USERS_ROUTE } from "../../../../constants/routes"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"

export function TenantAdminNavItems() {
    return (
        <>
            <LocalizedStrict id="tenant-nav-item-home">
                <NavMenuItem icon={faHome} dest={TENANT_ADMIN_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="tenant-nav-item-organization-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faBuilding} dest={TENANT_ADMIN_ORGANIZATION_ROUTE} title="Organization">
                    <LocalizedStrict id="tenant-nav-item-users">
                        <NavMenuSubItem route={TENANT_USERS_ROUTE}>Users</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="tenant-nav-item-administrators">
                            <NavMenuSubItem route="/">Administrators</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
